<div class="progress-bar">
  <div class="percentage" [style.left]="progressValue">
    <label class="sr-only">{{ 'progress-bar.label' | translate: { progressValue: roundedCurrentValue } }}</label>
    <span class="currentValue" [countUp]="currentValue" [options]="{ duration: 1, suffix: suffix }" aria-hidden="true">
      0</span
    >
  </div>
  <div class="bar" [style.width]="progressValue" [style.min-width]="progressValue"></div>
</div>
